<!--Translated-->
<template>
  <div class="cwrap cwrap--total marginbottom--standart">
    <!--TODO: №1 Защита Юзера -->
    <!--TODO: Stas верстка - ГОТОВО 15.01.2025-->
    <!--TODO: Витя Логика цен для ЗАЩИТЫ У ЮЗЕРА-->
    <!--TODO: Витя ЗАКОМЕНЧЕНЫ УСЛОВИЯ ИЗ ЗАЩИТЫ У МЕНЕДЖЕРА, нужно поменять на соответствующее условие тут-->
    <!--TODO: САША Перевод-->

    <div class="cblock cblock--totalprice2025 el--borders-all el--rounded-all">
      <!--Иконка с инфой, также инфа в блоке ниже по финальной цене-->
      <div
        class="infoicon"
        v-tooltip="{
          text: $t('ProgramTables:Tooltip.Text'),
          classList: [
            'tooltip',
            'tooltip--top',
            'tooltip--toright',
            'tooltip--oneline',
            'tooltip--anim1',
          ],
        }"
      >
        <div v-svg="{ name: 'info2025' }"></div>
      </div>
      <template v-if="program?.client_discount > 0">
        <div class="cblock__line">
          <div class="cblock__line-block">
            <span>{{ $t('ProgramTables:Sum') }} </span>
            <span>{{ calcMethodShort }}:</span>
            <span class="this-price">₾ {{ formatNumber(totalCostNew) }}</span>
          </div>
        </div>
        <div class="cblock__line" v-if="totalCostNewDiscount > 0">
          <div class="cblock__line-block">
            <span>{{ $t('ProgramTables:DiscountSum') }}</span>
            <span>{{ calcMethodShort }}:</span>
            <span class="this-price"
              >₾ {{ formatNumber(totalCostNewDiscount) }}</span
            >
          </div>
        </div>
      </template>
      <div class="cblock__line">
        <div
          class="cblock__line-block uni_text-accentcolor uni_text-bold"
          v-tooltip="{
            text: $t('ProgramTables:Tooltip.Text'),
            classList: [
              'tooltip',
              'tooltip--top',
              'tooltip--toleft',
              'tooltip--oneline',
              'tooltip--anim1',
            ],
          }"
        >
          <span>
            {{
              program.client_discount > 0
                ? $t('ProgramTables:DiscountSumFinal')
                : $t('ProgramTables:Sum')
            }}
          </span>
          <span>{{ calcMethodShort }}:</span>
          <span class="this-price"
            >₾ {{ formatNumber(totalCostNewWithDiscount) }}</span
          >
        </div>
      </div>
    </div>
    <!--TODO: ДО СЮДА + удалить что ниже-->

    <div v-if="pestsProductsMapped.length">
      <div
        class="chead el--borders-top el--borders-sides el--rounded-top margintop--standart"
      >
        <div class="chead__line-block">
          <div
            class="vsvg vsvg--standart chead_icon"
            v-svg="{ name: 'badobject' }"
          ></div>
          <div class="chead_text">
            {{ $t('ProgramTables:ListPests:Title') }}
          </div>
        </div>
      </div>

      <div class="cblock el--rounded-bottom">
        <table class="table--type1 table--withhead table--paycheck">
          <thead>
            <tr>
              <th class="tbl-cellproduct">
                {{ $t('ProgramTables:ListPests:Name') }}
              </th>
              <th class="col">{{ $t('ProgramTables:ListPests:Pack') }}</th>
              <th class="col" v-if="isWater">
                {{ $t('ProgramTables:ListPests:Volume1') }}
                {{ calcMethodShort }}
                {{ $t('ProgramTables:ListPests:Volume2') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListPests:Volume3') }} 1
                {{ $t('ProgramTables:ListPests:Volume4') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListPests:Volume3') }} {{ area }}
                {{ $t('ProgramTables:ListPests:Volume4') }}
              </th>
              <th class="col">{{ $t('ProgramTables:ListPests:Count') }}</th>
              <th class="col">{{ $t('ProgramTables:ListPests:Avg') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr class="row" v-for="row in pestsProductsMapped" :key="row.id">
              <td>{{ row.product.name }}</td>
              <td>{{ row.product.picking }}</td>
              <td v-if="isWater">{{ formatNumber(row.quantity) }}</td>
              <td>{{ formatNumber(row.totalVolume) }}</td>
              <td>{{ formatNumber(row.forArea) }}</td>
              <td>{{ formatNumber(row.packages) }}</td>
              <td>{{ row.packagesInt.toLocaleString('ru-RU') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="stimulatorProductsMapped.length">
      <div
        class="chead el--borders-top el--borders-sides el--rounded-top margintop--standart"
      >
        <div class="chead__line-block">
          <div
            class="vsvg vsvg--standart chead_icon"
            v-svg="{ name: 'stimulator' }"
          ></div>
          <div class="chead_text">
            {{ $t('ProgramTables:ListStimulations:Title') }}
          </div>
        </div>
      </div>

      <div class="cblock el--rounded-bottom">
        <table class="table--type1 table--withhead table--paycheck">
          <thead>
            <tr>
              <th class="tbl-cellproduct">
                {{ $t('ProgramTables:ListStimulations:Name') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListStimulations:Pack') }}
              </th>
              <th class="col" v-if="isWater">
                {{ $t('ProgramTables:ListPests:Volume1') }}
                {{ calcMethodShort }}
                <!--fixme-->
                {{ $t('ProgramTables:ListPests:Volume2') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListPests:Volume3') }} 1
                {{ $t('ProgramTables:ListPests:Volume4') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListPests:Volume3') }} {{ area }}
                {{ $t('ProgramTables:ListPests:Volume4') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListStimulations:Count') }}
              </th>
              <th class="col">
                {{ $t('ProgramTables:ListStimulations:Avg') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              class="row"
              v-for="row in stimulatorProductsMapped"
              :key="row.id"
            >
              <td>{{ row.product.name }}</td>
              <td>{{ row.product.picking }}</td>
              <td v-if="isWater">{{ formatNumber(row.quantity) }}</td>
              <td>{{ formatNumber(row.totalVolume) }}</td>
              <td>{{ formatNumber(row.forArea) }}</td>
              <td>{{ formatNumber(row.packages) }}</td>
              <td>{{ row.packagesInt.toLocaleString('ru-RU') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="cwrap">
      <div
        class="chead el--borders-top el--borders-sides el--rounded-top margintop--standart"
      >
        <div class="chead__line-block">
          <div
            class="vsvg vsvg--standart chead_icon"
            v-svg="{ name: 'paycheck' }"
          ></div>
          <div class="chead_text">
            {{ $t('ProgramTables:FooterTable:Header') }}
          </div>
        </div>
      </div>

      <!--TODO-->
      <div
        class="cblock cblock--analizetable el--rounded-bottom el--borders-sides el--borders-bottom"
      >
        <div class="cblock__internal">
          <div class="cblock__line paycheckfinal">
            <!--col1-->
            <div class="paycheckfinal_block paycheckfinal_block--dates">
              <div class="paycheckfinal_block-line">
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:DateCreate') }}
                </div>
                <div class="paycheckfinal_block-textdata">{{ createdAt }}</div>
              </div>
              <div class="paycheckfinal_block-line">
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:DateEdit') }}
                </div>
                <div class="paycheckfinal_block-textdata">{{ updatedAt }}</div>
              </div>
            </div>

            <div class="el--decorlinevertical"></div>

            <!--N.B. - добавить "paycheckfinal_block--finalprice"
            к колонке, или строке, значение которой нужно
            выделить зеленым цветом-->

            <!--col2-->
            <div class="paycheckfinal_block">
              <!--aby Сумма в лари-->
              <div class="paycheckfinal_block-line">
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:SumGel') }}
                </div>
                <div
                  class="paycheckfinal_block-textdata"
                  v-if="isFinite(totalPrice)"
                >
                  {{
                    Number.isFinite(totalPrice)
                      ? '₾ ' + formatNumber(totalPrice)
                      : '-'
                  }}
                </div>
              </div>

              <!--Скидка %-->
              <div
                class="paycheckfinal_block-line"
                :class="{
                  'paycheckfinal_block--finalprice':
                    program.client_discount > 0,
                }"
              >
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:Discount') }}
                </div>
                <div class="paycheckfinal_block-textdata">
                  {{ program.client_discount || 0 }}%
                </div>
              </div>

              <!--Сумма скидки в лари-->
              <div
                class="paycheckfinal_block-line"
                :class="{
                  'paycheckfinal_block--finalprice':
                    program.client_discount > 0,
                }"
              >
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:DiscountSum') }}
                </div>
                <div class="paycheckfinal_block-textdata">
                  ₾
                  {{
                    formatNumber(
                      (totalPrice / 100) * (program.client_discount || 0)
                    )
                  }}
                </div>
              </div>
            </div>

            <div class="el--decorlinevertical"></div>

            <!--col3-->
            <div class="paycheckfinal_block">
              <!--Итоговая сумма в лари-->
              <div class="paycheckfinal_block-line">
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:SumFinal') }}
                </div>
                <div class="paycheckfinal_block-textdata">
                  ₾
                  {{ formatNumber(totalPriceWithDiscount) }}
                </div>
              </div>

              <div class="paycheckfinal_block-line">
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:SumDollar') }}
                </div>
                <div class="paycheckfinal_block-textdata">
                  {{
                    Number.isFinite(totalPriceWithDiscountUSD)
                      ? '$ ' + formatNumber(totalPriceWithDiscountUSD)
                      : '-'
                  }}
                </div>
              </div>

              <div class="paycheckfinal_block-line">
                <div class="paycheckfinal_block-textkey">
                  {{ $t('ProgramTables:FooterTable:SumEuro') }}
                </div>
                <div class="paycheckfinal_block-textdata">
                  {{
                    Number.isFinite(totalPriceWithDiscountEU)
                      ? '€ ' + formatNumber(totalPriceWithDiscountEU)
                      : '-'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapState, mapGetters } from 'vuex';
import { mutationTypes } from '@/store/modules/clientsArea/programs';
import { staticData } from '@/store/modules/plantsCare';

export default {
  name: 'UserProgramTables',
  computed: {
    ...mapGetters(['plantsCareProductsAsMap', 'udPricesMap']),
    ...mapState({
      isSaving: (state) => state.userDefence.isSaving,
      program: (state) => state.userDefence.program,
      products: (state) => state.plantsCare.products,
      calcMethod: (state) => state.userDefence.program.calculation_method_id,
      area: (state) => state.userDefence.program.place_area,
      phases: (state) => state.userDefence.programPhases,
      pestsProducts: (state) => state.userDefence.programPestsProducts,
      stimulatorProducts: (state) =>
        state.userDefence.programTypesStimulationProducts,
      createdAt(state) {
        return state.userDefence.program.date_create
          ? format(
              new Date(state.userDefence.program.date_create),
              'dd.MM.yyyy HH:MM'
            )
          : this.$t('ProgramTables:Data:NotSaved');
      },
      updatedAt: (state) =>
        state.userDefence.program.date_update
          ? format(
              new Date(state.userDefence.program.date_update),
              'dd.MM.yyyy HH:MM'
            )
          : '-',
    }),
    isWater() {
      return this.calcMethod < 3;
    },
    calcMethodShort() {
      return staticData.calculationMethodsShort[this.calcMethod];
    },
    totalCost() {
      return this.formatNumber(
        Object.values(this.udPricesMap).reduce((a, b) => a + b, 0)
      );
    },
    activePhases() {
      return this.phases.filter((p) => this.udPricesMap[p.id] > 0);
    },
    totalWaterVolume() {
      return this.activePhases.reduce((a, b) => a + b.volume_per_ha, 0);
    },
    totalCostNew() {
      const pricePerHa = this.totalPrice / this.area;
      if (this.isWater && this.totalWaterVolume === 0) {
        return 0;
      }
      return this.isWater
        ? pricePerHa *
            ((this.calcMethod === 2 ? 1000 : 100) / this.totalWaterVolume) *
            this.activePhases.length
        : pricePerHa;
    },
    totalCostNewDiscount() {
      return (this.totalCostNew * this.program.client_discount) / 100;
    },
    totalCostNewWithDiscount() {
      return this.totalCostNew - this.totalCostNewDiscount;
    },
    pestsProductsMapped() {
      return this.mapRows(this.pestsProducts);
    },
    stimulatorProductsMapped() {
      return this.mapRows(this.stimulatorProducts, false);
    },
    totalPrice() {
      return [
        ...this.pestsProductsMapped,
        ...this.stimulatorProductsMapped,
      ].reduce((a, b) => a + b.totalPrice, 0);
    },
    totalPriceWithDiscount() {
      return (
        this.totalPrice - (this.totalPrice * this.program.client_discount) / 100
      );
    },
    totalPriceWithDiscountUSD() {
      return this.totalPriceWithDiscount / this.exchangeUSD;
    },
    totalPriceWithDiscountEU() {
      return this.totalPriceWithDiscount / this.exchangeEU;
    },
    exchangeUSD: {
      get() {
        return this.program.rate_dollar;
      },
      set(rate) {
        this.$store.commit(mutationTypes.setRateUSD, rate);
      },
    },
    exchangeEU: {
      get() {
        return this.program.rate_euro;
      },
      set(rate) {
        this.$store.commit(mutationTypes.setRateEU, rate);
      },
    },
    totalPriceUSD() {
      return this.program.rate_dollar
        ? this.totalPrice / this.program.rate_dollar
        : null;
    },
    totalPriceEU() {
      return this.program.rate_euro
        ? this.totalPrice / this.program.rate_euro
        : null;
    },
  },
  methods: {
    formatNumber(num) {
      return num.toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    round(num) {
      const result = Math.round(num);
      return result === 0 && num > 0 ? 1 : result;
    },
    mapRows(list, forPests = true) {
      const result = [];
      for (const phase of this.phases) {
        const products = list.filter(
          (pp) =>
            pp.program_phase_id === phase.id &&
            pp.is_selected &&
            pp.quantity > 0
        );
        for (const objPropuct of products) {
          let product = result.find((p) => p.id === objPropuct.product_id);
          if (!product) {
            product = { id: objPropuct.product_id, quantity: 0 };
            result.push(product);
          }
          product.quantity += objPropuct.quantity;
        }
      }
      return result
        .map((p) => ({
          ...p,
          product: this.plantsCareProductsAsMap[p.id],
        }))
        .map((e) => this.calc(e, forPests))
        .filter(({ packagesInt }) => Number.isSafeInteger(packagesInt));
    },
    calc(input, forPests) {
      let totalVolume = input.quantity;
      if (this.isWater) {
        totalVolume = this.phases.reduce((acc, cur) => {
          let q = 0;
          const list = forPests ? this.pestsProducts : this.stimulatorProducts;
          const products = list.filter(
            (pp) =>
              pp.program_phase_id === cur.id &&
              pp.product_id === input.id &&
              pp.is_selected === 1
          );
          for (const product of products) {
            const divider = this.calcMethod === 2 ? 1000 : 100;
            q += (product.quantity * cur.volume_per_ha) / divider;
          }
          return acc + q;
        }, 0);
      }

      const forArea = totalVolume * this.area;
      const packages = forArea / input.product.picking;
      const packagesInt = this.round(packages);
      return {
        ...input,
        totalVolume,
        forArea,
        packages,
        packagesInt,
        totalPrice: packagesInt * input.product.price,
      };
    },
  },
};
</script>
